import { css } from "lit";

export const styles = css`
  .title-slide {
    --title-slide-image-width: 680px;
    --title-slide-class-artwork-height: 70px;
    background-color: var(--color-white);
    width: 100%;
    height: 100%;
    display: flex;
    white-space: pretty;
  }

  .tall,
  .mobile-tall {
    flex-direction: column-reverse;
  }

  .content {
    flex-grow: 1;
    height: var(--slide-default-height);
    padding: var(--size-7);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    width: 80%;
  }

  .tall .artwork-container,
  .mobile-tall .artwork-container {
    width: 100%;
  }

  .tall .content,
  .mobile-tall .content {
    width: 100%;
  }

  .artwork-container {
    width: var(--title-slide-image-width);
    height: var(--slide-default-height);
    background-color: var(--slide-accent-color);
    display: flex;
    align-self: center;
    justify-content: center;
  }

  .artwork {
    width: 100%;
    height: 100%;
    object-fit: cover;
    margin: 0px;
  }

  .secondary-content {
    display: flex;
    flex-direction: row;
    margin-top: auto;
  }

  .secondary-artwork {
    height: var(--title-slide-class-artwork-height);
    aspect-ratio: 1 / 1;
    border-radius: var(--radius-lg);
  }

  .secondary-title {
    margin-left: var(--size-1-5);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  ::slotted([slot="session-number"]) {
    font-weight: var(--font-weight-semibold);
    font-size: var(--font-size-3xl);
    line-height: var(--line-height-normal);
    color: var(--color-gray);
  }

  ::slotted([slot="session-name"]) {
    font-weight: var(--font-weight-black);
    font-size: var(--font-size-7xl);
    line-height: var(--line-height-none);
    overflow-wrap: anywhere;
  }

  ::slotted([slot="class-name"]) {
    font-weight: var(--font-weight-semibold);
    font-size: var(--font-size-3xl);
    line-height: var(--line-height-none);
    margin-bottom: var(--size-0-5);
  }

  ::slotted([slot="teacher-name"]) {
    font-weight: var(--font-weight-normal);
    font-size: var(--font-size-2xl);
    line-height: var(--line-height-none);
  }
`;
